import {Ref, RefCallback, useCallback} from 'react';
import {setRef} from '../render-utils';

export function useForwardRef<T>(...forwards: Ref<T>[]): RefCallback<T> {
	return useCallback((ref) => {
		for (let forwarder of forwards) {
			setRef(ref, forwarder);
		}
	}, forwards);
}
